window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();



/**
 * Helper: Retrieve URL params by name
 */
var getUrlParameter = function getUrlParameter(sParam) 
{
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split(`&`),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split(`=`);

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

/**
 * Retrieve URL params
 */

// Retrieve the Section On/Off params
var fltr = getUrlParameter('fltr');
var hdr  = getUrlParameter('hdr');
var shp  = getUrlParameter('shp');

/**
 * Add Salesforce donation tracking
 */

// Retrieve the Marketing Tag params
var src = getUrlParameter(`src`);
var rsp = getUrlParameter(`rsp`);
var ver = query_ver = getUrlParameter(`v`); 
var cookie_ver = "";

// Get tracking vars from 
//console.log("Query V: " + query_ver);
var cookie_json = decodeURIComponent(getCookie('ijm.params'));
//console.log("Cookie JSON: " + cookie_json);
if ( typeof cookie_json !== 'undefined' && cookie_json.length > 0 )
{
  var cookie_params = JSON.parse(cookie_json);
  // src
  if ( typeof cookie_params['src'] !== 'undefined' && cookie_params['src'].length > 0 )
    src = cookie_params['src'];
  // rsp
  if ( typeof cookie_params['rsp'] !== 'undefined' && cookie_params['rsp'].length > 0 )
    rsp = cookie_params['rsp'];
  // ver
  if ( typeof cookie_params['v'] !== 'undefined' && cookie_params['v'].length > 0 )
  {
    cookie_ver = cookie_params['v'];

    if ( query_ver && query_ver.length > 0 )
    {
      cookie_ver_first = cookie_ver.split("|", 1);
      //console.log("Cookie First V: " + cookie_ver_first);
      ver = cookie_ver_first + "|" + query_ver;
    }
    else
    {
      ver = cookie_ver;
    }
  }
}
else 
{
  var query_params = [];
  // src
  if ( src && src.length > 0 )
    query_params['src'] = src;
  // ver 
  if ( ver && ver.length > 0 )
    query_params['ver'] = ver;  
  // rsp
  if ( rsp && rsp.length > 0 )
    query_params['rsp'] = rsp;
  // Set cookie
  if( (src && src.length > 0)
    || (rsp && rsp.length > 0)
    || (ver && ver.length > 0)
  ) 
  {
    let query_object = { src: src, v: ver, rsp: rsp };
    let query_json = JSON.stringify(query_object);
    setCookie("ijm.params", query_json, 0.0416666, "/", "ijm.org");
  }
}

// Send Marketing Tag values to the Cart note field
if( (src && src.length > 0)
  || (rsp && rsp.length > 0)
  || (ver && ver.length > 0)
) 
{
  var httpRequest = new XMLHttpRequest()
  httpRequest.onreadystatechange = function (data) {
    // code
  }
  httpRequest.open(`POST`, `/cart/update.js`);
  httpRequest.setRequestHeader(`Content-Type`, `application/x-www-form-urlencoded`);
  var note = ``;
  // Append the source
  if ( src && src.length > 0 )
  {
    note += `src__` + encodeURIComponent(src);
  }
  else
  {
    note += `src__web`;
  }
  // Append the response
  if ( rsp && rsp.length > 0 )
  {
    note += `,rsp__` + encodeURIComponent(rsp);
  }
  else
  {
    note += `,rsp__online`;
  }
  // Append the version
  if (ver && ver.length > 0)
  {
    note += `,ver__` + encodeURIComponent(ver);
  }
  // Add the note to the cart Note field
  httpRequest.send(`note=` + note);
}

$(document).ready(function() {

  // Turn sections on/off based on url params
  if ( fltr == 0 )
  {
    $('#hero-filter').hide();
  }
  if ( hdr == 0 )
  {
    $('#products-header').hide();
  }
  if ( shp == 0 )
  {
    $('#shopify-section__shop-by-need').hide();
    $('#shopify-section-footer-panels').css('margin-top', '60px');
  }

  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // smoothscroll
  // Select all links with hashes
  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
      &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });

  // dropdowns
  $('[data-dropdown-trigger]').on('click', function (e) {
    e.preventDefault();
    var dropdownTarget = $(this).attr('data-dropdown-trigger');
    $('[data-dropdown="' + dropdownTarget + '"]').toggleClass('dropdown--visible');
  });

  // $('[href="#"]').on('click', function (e) {
  //   e.preventDefault();
  // });

  // search-panel
  $('[data-search-panel="trigger"]').on('click', function (e) {
    e.preventDefault();
    var container = $('[data-search-panel="container"]');
    container.toggleClass('search-panel--visible');

    if (container.hasClass('search-panel--visible')) {
      $('[data-search-panel="input"]').focus();
    }
  });

  // $('#search').on('submit', function () {
  //   var $input = $(this).find('#q')
  //   var value = $input.val()
  //   $input.val(value + '*')
  // })

  // offcanvas mobile
  $('[data-offcanvas-toggle="offcanvas"]').on('click', function (e) {
    e.preventDefault();
    var container = $('[data-offcanvas="offcanvas"]');
    container.toggleClass('offcanvas--visible');
  });

  // flyout panel
  $('[data-flyout-toggle]').on('click', function (e) {
    e.preventDefault();
    console.log('flyout');
    var target = $(this).attr('data-flyout-toggle');
    var flyout = $('[data-flyout="' + target + '"]');
    flyout.toggleClass('offcanvas--visible');
  });

  // video-modal
  $('[data-video-trigger]').on('click', function (e) {
    if ($(window).width() > 750) {
      e.preventDefault();
      var videoTarget = $(this).attr('data-video-trigger');
      var videoContent = $(this).attr('data-video-embed');
      $('[data-video="' + videoTarget + '"] [data-video-wrapper]').html(videoContent);
      $('[data-video="' + videoTarget + '"]').toggleClass('video-modal--visible');
    } else {
      return;
    }
  });

  // filter-modal
  $('[data-filter-trigger]').on('click', function (e) {
    e.preventDefault();
    var filterTarget = $(this).attr('data-filter-trigger');
    $('[data-filter="' + filterTarget + '"]').toggleClass('filter-modal--visible');

    if (filterTarget == 'clear') {
      $(this).parent().prev('ul.filter-modal__list').find('input[type="checkbox"]').prop('checked', false)
    }

    if (filterTarget == 'donate') {
      $quickdonationForm.attr('action', $(this).attr('href'));
    }
  });



  // filter-panel
  $('.jsFilterTrigger').on('click', function()
  {
    $('.filters__trigger').toggleClass('is-triggered');
    $('.jsFilterPanel').slideToggle(300);
  });



  function labelUp ($input) {
    $input.addClass('input--label-up');
  }

  function labelDown ($input) {
    $input.removeClass('input--label-up');
  }

  $('[data-float-label] input').on('focus', function () {
    var $inputContainer = $(this).closest('[data-float-label]')
    labelUp($inputContainer);
    $inputContainer.addClass('input--focus');
  });

  $('[data-float-label] input').on('blur', function () {
    var $inputContainer = $(this).closest('[data-float-label]')
    $inputContainer.removeClass('input--focus');

    if (!$(this).val()) {
      labelDown($inputContainer);
    } else {
      labelUp($inputContainer);
    }
  });

  function URLToArray(url) {
    var request = {};
    var pairs = url.substring(url.indexOf('?') + 1).split('&');
    for (var i = 0; i < pairs.length; i++) {
        if(!pairs[i])
            continue;
        var pair = pairs[i].split('=');
        request[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
     }
     return request;
   }

   function ArrayToURL(array) {
    var pairs = [];
    for (var key in array)
      if (array.hasOwnProperty(key))

        pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(array[key]));
    return pairs.join('&');
  }

  // quick donation form
  var $quickdonationForm = $('[data-quickdonation="form"]');
  var $quickdonationInput = $('[data-quickdonation="input"]');
  var $quickdonationSubmit = $('[data-quickdonation="submit"]');

  $quickdonationInput.on('keyup', function () {
    if (!$(this).val()) {
      $quickdonationSubmit.addClass('button--gray');
      $quickdonationSubmit.prop('disabled', true);
      $quickdonationSubmit.removeClass('button--primary');
    } else {
      $quickdonationSubmit.removeClass('button--gray');
      $quickdonationSubmit.prop('disabled', false);
      $quickdonationSubmit.addClass('button--primary');
    }

    // generate form action
    var quickdonationAction = $quickdonationForm.attr('action');
    var quickdonationParameters = URLToArray(quickdonationAction);
    quickdonationParameters.quantity = $quickdonationInput.val();
    quickdonationAction = ArrayToURL(quickdonationParameters);
    $quickdonationForm.attr('action', '/cart/add?' + quickdonationAction);
  });


  // product select
  var form = $('[data-component="form"]'),
    selectedPrice = $('[data-form="selected-price"]'),
    selectedVariant = $('[data-form="selected-variant"]'),
    prices = $('[data-form="price"]'),
    amountButtons = $('[data-amount-button]')

  prices.on('change', function() {
    selectedPrice.text($(this).data('form-value'))
    selectedVariant.text($(this).data('form-value-variant'))

    var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + $(this).val();
    window.history.replaceState({path: newurl}, '', newurl);
  })

  amountButtons.on('click', function() {
    var amountInput = $(this).parent().find('[data-form="amount"]');

    if ($(this).data('amount-button') === 'decrement' && amountInput.val() > 1) {
      amountInput.val(parseInt(amountInput.val()) - 1)
    } else if ($(this).data('amount-button') === 'increment') {
      amountInput.val(parseInt(amountInput.val()) + 1)
    }

    var checkedInput = $('input[name=price]:checked', '[data-component="form"]').val()
  })

  $('.product-form,.quickshop__form').on('submit', function (event) {
    $('button.button', this).prop('disabled', true)
  })

  // hero filters
  $('[data-type-all]').on('change', function () {
    var $this = $(this)
    var $parent = $this.parents('form')
    var $inputs = $('.filter-modal__list-item input')
    var $submit = $parent.find('[data-tags-filter-target]');
    var target = $submit.attr('data-tags-filter-target');
    $inputs.prop('checked', false)

    window.location = target
  })

  $('[data-tags-filter="form"]').change(function () {
    var selectedElements = $('[data-tags-filter="all-forms"]').find('input[data-tags-filter-checkbox]:checked');
    var selected = [];

    selectedElements.each(function () {
      selected.push($(this).attr('data-tags-filter-checkbox').split(' ').join('-').toLowerCase());
    });

    var submit = $(this).find('[data-tags-filter-target]');
    var target = submit.attr('data-tags-filter-target');
    submit.attr('href', target + '/' + selected.join('+'));
  });

  function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;

      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
  };  

  // product ajax
  function getProduct (productId) {
    var data = '{ node(id: "' + productId + '") { id ... on Product { title, productType, variants(first: 10) { edges { node { title price id compareAtPrice } } }, images(first: 1) { edges { node { src } } } } } }';

    var selectors = {};
    selectors.content = $('[data-quickshop="content"]');
    selectors.loader = $('[data-quickshop="loader"]');
    selectors.type = $('[data-quickshop="product-type"]');
    selectors.title = $('[data-quickshop="title"]');
    selectors.image = $('[data-quickshop="image"]');
    selectors.variantsSelect = $('[data-quickshop="variants-select"]');
    selectors.variantsPrice = $('[data-quickshop="variants-price"]');
    selectors.variantsName = $('[data-quickshop="variants-name"]');

    selectors.content.hide();
    selectors.loader.fadeIn(200);

    jQuery.ajax({
      type: "POST",
//       url: "https://store-ijm.myshopify.com/api/graphql", // Production
      url: "https://store-ijm-dev.myshopify.com/api/graphql", // Stage
      headers: {
//         "X-Shopify-Storefront-Access-Token":"87dbc0341efea26bd3eb46e8a75eff50", // Production
        "X-Shopify-Storefront-Access-Token":"dc91ce3864701b6b4d26645dc42e1288", // Stage
        "content-Type":"application/graphql"
      },
      data: data,
      success: function(data) {
        selectors.type.text(data.data.node.productType);
        selectors.title.text(data.data.node.title);

        // console.log(data.data.node);

        // image
        selectors.image.addClass('quickshop__image-' + data.data.node.title.replace(/\s+/g, '-').toLowerCase());        
        if (
          data.data.node.images.edges[0] !== undefined &&
          data.data.node.images.edges[0] !== null
        ) {
          selectors.image.css('background-image', 'url(' + data.data.node.images.edges[0].node.src + ')');
        } else {
          selectors.image.css('background-image', 'none');
        }

        // variants
        var defaultVariantFMV = 0;
        for (var i = 0; i < data.data.node.variants.edges.length; i++) {
          var variant = data.data.node.variants.edges[i].node.price;
          var variantTitle = data.data.node.variants.edges[i].node.title;
          var variantId = atob(data.data.node.variants.edges[i].node.id).replace('gid://shopify/ProductVariant/', '');
          var variantFMV = data.data.node.variants.edges[i].node.compareAtPrice;
          if ( typeof variantFMV === 'undefined' )
          {
            variantFMV = 0;
          }

          if (i === 0) {
            defaultVariantFMV = variantFMV;
            selectors.variantsSelect.html('');
            selectors.variantsPrice.html('$' + variant.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") );
            selectors.variantsName.html(variantTitle)
            selectors.variantsSelect.append('<option value="' + variantId + '" data-fmv="' + variantFMV + '" data-select-price="' + variant + '" data-select-name="' + variantTitle + '" selected="selected">' +  '$' + variant.replace(/\d(?=(\d{3})+\.)/g, '$&,') + '</option>');
          } else {
            selectors.variantsSelect.append('<option value="' + variantId + '" data-fmv="' + variantFMV + '" data-select-price="' + variant + '" data-select-name="' + variantTitle + '">' + '$' + variant.replace(/\d(?=(\d{3})+\.)/g, '$&,') + '</option>');
          }
        }

        selectors.variantsSelect.on('change', function (event) {
          selectors.variantsPrice.html('$' + $(this).find(':selected').data('select-price').replace(/\d(?=(\d{3})+\.)/g, '$&,'))
          selectors.variantsName.html($(this).find(':selected').data('select-name'))
        });

        // FMV
        var fieldFMV = document.getElementById("fieldFMV");
        if ( defaultVariantFMV > 0 )
        {
          fieldFMV.value = "$" + formatMoney(defaultVariantFMV);
        }

        // Check if the Engraving field should be visible or not
        if ( data.data.node.title.toLowerCase().includes('personalize') )
        {
          var fieldEngraving = document.getElementById("fieldEngraving");
          if ( fieldEngraving )
          {
            fieldEngraving.classList.remove('hide');
          }
        }

        selectors.content.fadeIn(200);
        selectors.loader.fadeOut(400);
      },
      error: function(data) {
        console.log(data);
      }
    })
  }

  // quickshop
  $(document).on('click', '[data-quickshop-trigger]', function (e) {
    e.preventDefault();
    $('[data-quickshop="quickshop"]').toggleClass('quickshop--visible');
    var productId = $(this).attr('data-quickshop-trigger');

    if (productId !== 'quickshop') {
      var product = btoa("gid://shopify/Product/" + productId);
      getProduct(product);
    }
  });

  // tabs
  $('[data-tabs-content]').not('[data-tabs-content-active]').hide();
  $('[data-tabs-trigger]').on('click', function (e) {
    e.preventDefault();

    if (!$(this).hasClass('panel__tab--active')) {
      var target = $(this).attr('data-tabs-trigger');

      $(this).closest('[data-tabs="container"]').find('[data-tabs-trigger]').removeClass('panel__tab--active');
      $(this).addClass('panel__tab--active');
      $(this).closest('[data-tabs="container"]').find('[data-tabs-content]').hide();
      $(this).closest('[data-tabs="container"]').find('[data-tabs-content="' + target + '"]').fadeIn(300);
    }
  });

  // footer search
  $('[data-footer-search-trigger]').on('click', function (e) {
    e.preventDefault();
    var target = $(this).attr('data-footer-search-trigger');
    var $search = $('[data-footer-search="' + target + '"]');
    $search.toggleClass('search-footer--opened');

    if ($search.hasClass('search-footer--opened')) {
      $('[data-footer-search-input="' + target + '"]').focus();
    }
  });

  // accordion
  $('[data-accordion-content]').slideUp(0);
  $('.accordion__header').on('click', function (e) {
    e.preventDefault();
    var $parent = $(this).parents('[data-accordion]')
    console.log($parent)
    $parent.find('[data-accordion-content]').slideToggle(100);
    $parent.find('[data-accordion-indicator]').toggleClass('accordion__indicator--opened');
  });



  /**
   * Urgent Message
   */

  // Get the urgent message
  var urgent = $('#shopify-section-urgent-message');

  // Get the urgent message close button
  var urgent_close = $('#urgent-message-close');

  // Get the urgent message CTA
  // var urgent_cta = document.getElementById('urgent-message-cta');

  // Check for the urgent message
  if ( urgent )
  {

      // Check if cookie has been set indicating that the Urgent Message has been dismissed.
      var hideUrgentMessage = getCookie("dismissedUrgentMessage");

      // If Urgent Message hasn't been dismissed, show it.
      if (!hideUrgentMessage)
      {
        $(urgent).removeClass('is-hidden');
      }

    // When the user clicks on close (x), close the modal
    if ( urgent_close )
    {
      urgent_close.on('click', function(event)
      {
        $(urgent).addClass('is-hidden');
        setCookie("dismissedUrgentMessage", 1, 0.0208333); // expires after ~30 mins
        // setCookie("dismissedUrgentMessage", 1); // session cookie
      });
    }
  }

});


// Hide the page loading overlay
// $(window).on('load', function() {
//   $("#page-loading-overlay").fadeOut();
// });


/**
 * Get/Set Cookies
 */

function setCookie(cname, cvalue, exdays=0, path="", domain="")
{
  if ( exdays > 0 )
  {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=" + path + ";domain=" + domain;
  }
  else
  {
    document.cookie = cname + "=" + cvalue + ";path=" + path + ";domain=" + domain;
  }
}

function getCookie(cname)
{
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++)
  {
    var c = ca[i];
    while (c.charAt(0) == ' ')
    {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0)
    {
       return c.substring(name.length, c.length);
    }
  }
  return "";
}


/**
 * Collaspse/Expand sections
 */

function collapseSection(element)
{
  // get the height of the element's inner content, regardless of its actual size
  var sectionHeight = element.scrollHeight;

  // temporarily disable all css transitions
  var elementTransition = element.style.transition;
  element.style.transition = '';

  // on the next frame (as soon as the previous style change has taken effect),
  // explicitly set the element's height to its current pixel height, so we
  // aren't transitioning out of 'auto'
  requestAnimationFrame(function()
  {
    element.style.height = sectionHeight + 'px';
    element.style.transition = elementTransition;

    // on the next frame (as soon as the previous style change has taken effect),
    // have the element transition to height: 0
    requestAnimationFrame(function()
    {
      element.style.height = 0 + 'px';
    });
  });

  // mark the section as "currently collapsed"
  element.setAttribute('data-collapsed', 'true');
}

function expandSection(element)
{
  // get the height of the element's inner content, regardless of its actual size
  var sectionHeight = element.scrollHeight;

  // have the element transition to the height of its inner content
  element.style.height = sectionHeight + 'px';

  // when the next css transition finishes (which should be the one we just triggered)
  element.addEventListener('transitionend', function(e) {
    // remove this event listener so it only gets triggered once
    element.removeEventListener('transitionend', arguments.callee);

    // remove "height" from the element's inline styles, so it can return to its initial value
    element.style.height = null;
  });

  // mark the section as "currently not collapsed"
  element.setAttribute('data-collapsed', 'false');
}

/**
 * Urgent Message
 */
/*
// Get the urgent message
var urgent = document.getElementById('shopify-section-urgent-message');

// Get the urgent message
var urgent_close = document.getElementById('urgent-message-close');

// Get the urgent message
var urgent_cta = document.getElementById('urgent-message-cta');

// Check for the urgent message
if ( urgent )
{

  // When the user clicks on close (x), close the modal
  // The urgent message is hidden for 15 minutes
  if ( urgent_close )
  {
    urgent_close.onclick = function(event)
    {
      collapseSection(urgent);
      setCookie("dismissedUrgentMessage", 1, 0.01);
    }
  }

  // When the user clicks on the CTA
  // The urgent message is hidden for 7 days
  if ( urgent_cta )
  {
    urgent_cta1.onclick = function(event)
    {
      collapseSection(urgent);
      setCookie("dismissedUrgentMessage", 1, 7);
    }
  }
}
*/